/*Add custom scritps */

// $(document).ready(function(){
//     //show phpMyAdmin | MailHog | Clear Cache
// 	var debugbar = (viewmode  == 1) ? mex.env.debug : parent.wex.env.debug;
// 	if (debugbar == true) {
// 		var hostname = location.hostname;
// 		var debugLink = '| <a href="//'+hostname+':8025" class="sitemapFooterLink">MailHog</a>';
// 		debugLink += '| <a href="//'+hostname+':8026" class="sitemapFooterLink">phpMyAdmin </a>';
// 		debugLink += '| <a href="/admin/manage/app/clearcache" class="sitemapFooterLink">Clear Cache</a>';

// 		$('#sitemapFooter').append(debugLink);
// 	}

// 	});

$(document).ready(function() {
    // Default
    scrollSpeed(150, 1600);
    // Custom Easing
    // jQuery.scrollSpeed(100, 800, 'easeOutCubic');

    
   
 
    //active current menu
    try {
        // Active current Menu
        // uk active menu

        // Decode Url
        var slug = decodeURIComponent($(location).attr('href'));
        var hash = decodeURIComponent(window.location.hash);
        var subLen = slug.length;

        if (slug.lastIndexOf('#') > -1) {
            subLen = slug.lastIndexOf('#');
            // substr after #
            hash = hash.substring(1, hash.length);
        }

        slug = slug.substring(parseInt(slug.lastIndexOf('/')) + 1, subLen);
        slug = slug.replace(/'/g, "\\'");

        if (slug != '') {
            var menu = $('[menu-slug="' + slug + '"][menu-bookmark="' + hash + '"]').first();
            menu.addClass('uk-active');
        } else {
            // Is Homepage
            var menu = $('[is-homepage=1]').first();
            menu.addClass('uk-active');
        }
    } finally {
    }
});

// https://jsfiddle.net/jaredwilli/jtqNY/
function print_r(obj, max, sep, level) {
    level = level || 0;
    max = max || 10;
    sep = sep || ' ';

    if (level > max) return '[WARNING: Too much recursion]\n';

    var i,
        result = '',
        tab = '',
        t = typeof obj;

    if (obj === null) {
        result += '(null)\n';
    } else if (t == 'object') {
        level++;

        for (i = 0; i < level; i++) {
            tab += sep;
        }
        if (obj && obj.length) {
            t = 'array';
        }

        result += '(' + t + ') :\n';
        for (i in obj) {
            try {
                result += tab + '[' + i + '] : ' + print_r(obj[i], max, sep, level + 1);
            } catch (error) {
                return '[ERROR: ' + error + ']\n';
            }
        }
    } else {
        if (t == 'string') {
            if (obj == '') obj = '(empty)';
        }
        result += '(' + t + ') ' + obj + '\n';
    }
    return result;
}
var var_dump = print_r;
